import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Onboarding from "@/pages/Onboarding";
import CapsulePlayer from "@/pages/CapsulePlayer";
import StatsPage from "@/pages/StatsPage";
import InstallPrompt from "@/components/InstallPrompt";
import NotificationScheduler from "@/components/NotificationScheduler";

export default function App() {
  useEffect(() => {
    // Register the PWA service worker on load. Kept side-effect-only so
    // it never blocks first paint.
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .catch(() => { /* SW registration is best-effort */ });
      });
    }
  }, []);

  return (
    <div className="App font-sans">
      <BrowserRouter>
        <Toaster position="top-center" theme="light" richColors />
        <Routes>
          <Route path="/" element={<Onboarding />} />
          <Route path="/capsule/:id" element={<CapsulePlayer />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <InstallPrompt />
        <NotificationScheduler />
      </BrowserRouter>
    </div>
  );
}
